import { createSlice } from '@reduxjs/toolkit';
import i18n from "i18next";

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';
import { validateDates } from 'utils/formatTime';
import { dispatch, store } from '../store';


// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  consultations: [],
  patient: {},
  searched: false,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },
  filters: {
    ipp: '',
    demandNumber: '',
    userName: '',
    userLogin: '',
    lastUpdateFrom: null,
    lastUpdateTo: null,
  },
};

const slice = createSlice({
  name: 'consultations',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.consultations = [];
      state.navig = initialState.navig;
      state.patient = initialState.patient;

    },

    // GET ConsultationHistory
    getConsultationHistorySuccess(state, action) {
      const { data, navig, patient } = action.payload;
      state.isLoading = false;
      state.consultations = data;
      state.patient = patient;
      state.navig = navig;
      state.error = null;

    },
    // SET Searched
    setSearched(state) {
      state.searched = true;
    },

    //  SORT & FILTER ConsultationHistory
    sortByConsultationHistory(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER ConsultationHistory
    paginationConsultationHistory(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },

    filterConsultationHistory(state, action) {
      state.filters = action.payload;
    },
    resetConsultationHistory(state) {
      state.consultations = initialState.consultations;
      state.patient = initialState.patient;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
      state.searched = initialState.searched;
      state.error = initialState.error;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByConsultationHistory,
  paginationConsultationHistory,
  filterConsultationHistory,
  resetConsultationHistory
} = slice.actions;

// ----------------------------------------------------------------------

export function getConsultationHistory() {
  const { consultationHistory: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());

    try {

      const start = new Date(filters.lastUpdateFrom).getTime();
      const end = new Date(filters.lastUpdateTo).getTime();
      const errors = validateDates({ start, end });
      if ((filters.ipp === initialState.filters.ipp)) {
        const errorLabel = 'REQUIRED';
        errors[errorLabel] = i18n.t("errors.required");
      }
      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      // Fixer lastUpdateTo à 23h59
      const lastUpdateTo = filters.lastUpdateTo ? new Date(new Date(filters.lastUpdateTo).setHours(23, 59, 59)).toISOString() : null;

      const filtersTrim = {};
      Object.keys(filters).forEach(item => filters[item] !== null && typeof(filters[item]) !== 'object'  ? filtersTrim[item] = filters[item].trim() : filtersTrim[item] = filters[item]);

      const response = await axios.post(API.path, {
        criteres: { ...filtersTrim, lastUpdateTo },
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.CONSULTDEMANDE
      });

      const { data } = response;

      dispatch(slice.actions.setSearched());

      if (data.patient.firstName === null || data.patient.birthName === null || data.patient.birthDate === null || data.patient.name === null)
        throw new Error('NO_PATIENT');

      if (data.data.length === 0) {

        const response = await axios.post(API.path, {
          action: ACTIONS.EXISTSDEMANDES,
          criteres: { ...filtersTrim, lastUpdateTo }

        });
        throw new Error(response?.data?.existDemands ? 'NO_CONSULT' : 'NO_RESULTS');
      }

      dispatch(slice.actions.getConsultationHistorySuccess(data));

    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));

    }
  };
}
